import { useCallback } from 'react';
import { AnyObject } from 'types/util/Object';
import { setObjectKeyCloned } from 'utils/objectUtils';

export default function useSettingsUpdate<
  ParentSettings extends AnyObject,
  ChildSettings extends ParentSettings[keyof ParentSettings]
>(
  initial: ChildSettings,
  updateSettings: (key: keyof ParentSettings, settings: ChildSettings) => Promise<any>,
  selfKey: keyof ParentSettings
) {
  return useCallback(
    <K extends keyof ChildSettings>(key: K, payload: ChildSettings[K]) => {
      return updateSettings(selfKey, setObjectKeyCloned(initial, key, payload));
    },
    [initial, selfKey, updateSettings]
  );
}
